import React from 'react';
import PropTypes from 'prop-types';
import {Container} from '../';

const ReportsContainer = ({children}) => {
  return (
    <Container title='Reports'>
      {children}
    </Container>
  )
}

export default ReportsContainer



// WEBPACK FOOTER //
// ./src/browser/components/reports/reports-container.js